import React, { createContext, useState, useContext, useCallback } from 'react';

const MessageContext = createContext();

export const useMessage = () => useContext(MessageContext);

export const MessageProvider = ({ children }) => {
    const [message, setMessage] = useState(null);

    const showMessage = useCallback((text, type = 'success', duration = 3000) => {
        const id = new Date().getTime();
        setMessage({ id, text, type });

        setTimeout(() => {
            setMessage(prev => (prev && prev.id === id ? null : prev));
        }, duration);
    }, []);

    const hideMessage = useCallback(() => {
        setMessage(null);
    }, []);

    return (
        <MessageContext.Provider value={{ showMessage, hideMessage }}>
            {children}
            {message && React.createElement(require('../Components/SystemMessage/SystemMessage').default, {
                message: message.text,
                type: message.type,
                onClose: hideMessage
            })}
        </MessageContext.Provider>
    );
};